import { render, staticRenderFns } from "./DeferReschedule.vue?vue&type=template&id=da53853a&scoped=true"
import script from "./DeferReschedule.vue?vue&type=script&lang=js"
export * from "./DeferReschedule.vue?vue&type=script&lang=js"
import style0 from "./DeferReschedule.vue?vue&type=style&index=0&id=da53853a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da53853a",
  null
  
)

export default component.exports